import { render, staticRenderFns } from "./GenericCUJournalCard.vue?vue&type=template&id=870a8816&scoped=true"
import script from "./GenericCUJournalCard.vue?vue&type=script&lang=js"
export * from "./GenericCUJournalCard.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/CU_artist.css?vue&type=style&index=0&id=870a8816&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "870a8816",
  null
  
)

export default component.exports